import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import userSelectors from 'store/user/selectors';
import quizActions from 'store/quiz/actions';
import event from 'utils/event';

import {
  CircularStartQuizButton,
  CircularCheckmarkQuizButton,
  CheckMarkSVG,
} from './StartQuizButton.styles';
import CheckMark from '../../assets/white_check.svg';

export class StartQuizButton extends Component {
  onClick = () => {
    const { goToQuiz, history, quiz } = this.props;

    event(`start-quiz`, [`click`, `start-quiz`, `${quiz.kind}`, quiz.id]);

    goToQuiz(quiz.id)
      .then((url) => {
        history.push(url);
      });
  }

  render() {
    const { quiz, statsByQuiz } = this.props;
    return statsByQuiz[quiz.id]
      ? (<CircularCheckmarkQuizButton onClick={ this.onClick }>
        <CheckMarkSVG src={CheckMark} />
      </CircularCheckmarkQuizButton>)
      : (<CircularStartQuizButton onClick={ this.onClick } kind={ quiz.kind }>
      &#9658;
      </CircularStartQuizButton>);
  }
}

StartQuizButton.propTypes = {
  quiz: PropTypes.object.isRequired,
  goToQuiz: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  statsByQuiz: PropTypes.object,
};

export default connect((state) => {
  return {
    statsByQuiz: userSelectors.selectedUserStatsByQuizCompleted(state),
  };
}, {
  goToQuiz: quizActions.goToQuiz,
})(withRouter(StartQuizButton));
